import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';
import { UserService } from '@app/services/User/user.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    
    API_BASE_PATH= environment.API_URL;

    constructor(private accountService: UserService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if user is logged in and request is to the api url
        //const user = this.accountService.userValue; TODO -local storage user 
        //const isLoggedIn = user && user.token; TODO -local storage user 
        const token = sessionStorage.getItem('token');
        const isLoggedIn = token;
        const isApiUrl = request.url.startsWith(`${this.API_BASE_PATH}`);
        if (isLoggedIn && isApiUrl) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });
        }

        return next.handle(request);
    }
}